export const GET_TADATA_STARTED = 'GET_TADATA_STARTED';
export const GET_TADATA_SUCCESS = 'GET_TADATA_SUCCESS';
export const GET_TADATA_ERROR = 'GET_TADATA_ERROR';

export const GET_TICKETS_AGING_STARTED = 'GET_TICKETS_AGING_STARTED';
export const GET_TICKETS_AGING_SUCCESS = 'GET_TICKETS_AGING_SUCCESS';
export const GET_TICKETS_AGING_ERROR = 'GET_TICKETS_AGING_ERROR';